import {ApplicantOnboarding, ApplicantOnboardingFormData} from '../types';

import {complete} from '../../../../lib/api/v1/applicant-onboarding/complete';
import {start} from '../../../../lib/api/v1/applicant-onboarding/start';
import {ApiResponse, ApiResponseError} from '../../../../lib/api/v1/types';
import {SerializeTo} from '../../../../utils/serializer/serialize';


export class ApplicantOnboardingService {
  static async start(applicantId: string): Promise<ApiResponse<ApplicantOnboarding>> {
    try {
      const response = await start(applicantId);
      const body = await response.json();

      if (response.ok) {
        return {
          ok: true,
          data: SerializeTo.CamelCase<ApplicantOnboarding>(body.applicant_onboarding),
          error: undefined,
        };
      }

      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: unknown) {
      console.error(error);
      throw error;
    }
  }

  static async complete(
    applicantId: string,
    applicantOnboarding: ApplicantOnboardingFormData
  ): Promise<ApiResponse<ApplicantOnboarding>> {
    try {
      const applicantOnboardingJSON = SerializeTo.SnakeCase(applicantOnboarding);

      const response = await complete(applicantId, applicantOnboardingJSON);
      const body = await response.json();

      if (response.ok) {
        const applicantOnboarding = SerializeTo.CamelCase<ApplicantOnboarding>(body.applicant_onboarding);

        return {
          ok: true,
          data: applicantOnboarding,
          error: undefined,
        };
      }

      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: unknown) {
      console.error(error);
      throw error;
    }
  }
}
